import React from "react";

const About = () => (
    <section className="about" id="about">
      <div className="about-content">
        <h2>For the Backbone of Bharat's Growth</h2>
        <p>
          India's industrial growth depends on skilled professionals who build, maintain, and innovate across critical sectors. From massive infrastructure projects that connect cities to precision manufacturing on factory floors, RIVET bridges the gap between India's talented Civil, Mechanical, Electrical workforce and the opportunities that drive our nation forward.
        </p>
        <p>
          We understand that finding the right talent shouldn't be complicated by layers of middlemen and lengthy processes. That's why RIVET creates direct connections between skilled professionals and employers, ensuring faster hiring, better matches, and sustainable career growth for India's core engineering community.
        </p>
        
        <div className="about-features">
          <div className="feature-section">
            <h3>🎯 For Employers</h3>
            <ul>
              <li>✓ Access to pre-verified Engineers, Technicians, and Skilled Operators</li>
              <li>✓ Rapid recruitment process with quality-assured candidates</li>
            </ul>
          </div>
          
          <div className="feature-section">
            <h3>🚀 For Job Seekers</h3>
            <ul>
              <li>✓ Direct access to verified job opportunities across India</li>
              <li>✓ Transparent salary negotiations and career growth paths</li>
            </ul>
          </div>
          
          <div className="feature-section">
            <h3>💼 Our Commitment</h3>
            <ul>
              <li>✓ 100% satisfaction guarantee with dedicated support</li>
              <li>✓ Building India's most trusted core sector job platform</li>
        </ul>
          </div>
        </div>
      </div>
    </section>
);

export default About; 